import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/theme/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "paragraphs"
    }}>{`Paragraphs`}</h1>
    <p>{`This is a paragraph showing `}<em parentName="p">{`emphasis`}</em>{` `}<strong parentName="p">{`strong`}</strong>{` `}<del parentName="p">{`strikethrough`}</del></p>
    <p>{`This text is `}<strong parentName="p"><em parentName="strong">{`really important`}</em></strong>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-markdown"
      }}>{`This is a paragraph showing _emphasis_ **strong** ~~strikethrough~~
This text is ***really important***.
`}</code></pre>
    <h1 {...{
      "id": "blockquotes"
    }}>{`Blockquotes`}</h1>
    <blockquote>
      <p parentName="blockquote">{`Dorothy followed her through many of the beautiful rooms in her castle.`}</p>
    </blockquote>
    <pre><code parentName="pre" {...{
        "className": "language-markdown"
      }}>{`> Dorothy followed her through many of the beautiful rooms in her castle.
`}</code></pre>
    <h1 {...{
      "id": "blockquotes-with-other-elements"
    }}>{`Blockquotes with Other Elements`}</h1>
    <blockquote>
      <h4 parentName="blockquote" {...{
        "id": "the-quarterly-results-look-great"
      }}>{`The quarterly results look great!`}</h4>
      <ul parentName="blockquote">
        <li parentName="ul">
          <p parentName="li">{`Revenue was off the chart.`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`Profits were higher than ever.`}</p>
          <p parentName="li"><em parentName="p">{`Everything`}</em>{` is going according to `}<strong parentName="p">{`plan`}</strong>{`.`}</p>
        </li>
      </ul>
    </blockquote>
    <pre><code parentName="pre" {...{
        "className": "language-markdown"
      }}>{`> #### The quarterly results look great!
>
> - Revenue was off the chart.
> - Profits were higher than ever.
>
>  *Everything* is going according to **plan**.
`}</code></pre>
    <h1 {...{
      "id": "ordered-lists"
    }}>{`Ordered Lists`}</h1>
    <ol>
      <li parentName="ol">{`First item`}</li>
      <li parentName="ol">{`Second item`}</li>
      <li parentName="ol">{`Third item`}</li>
      <li parentName="ol">{`Fourth item`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-markdown"
      }}>{`1. First item
2. Second item
3. Third item
4. Fourth item
`}</code></pre>
    <h2 {...{
      "id": "with-indentation"
    }}>{`With indentation`}</h2>
    <ol>
      <li parentName="ol">{`First item`}</li>
      <li parentName="ol">{`Second item`}</li>
      <li parentName="ol">{`Third item`}<ol parentName="li">
          <li parentName="ol">{`Indented item`}</li>
          <li parentName="ol">{`Indented item`}</li>
        </ol></li>
      <li parentName="ol">{`Fourth item`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-markdown"
      }}>{`1. First item
2. Second item
3. Third item
    1. Indented item
    2. Indented item
4. Fourth item
`}</code></pre>
    <h1 {...{
      "id": "unordered-lists"
    }}>{`Unordered Lists`}</h1>
    <ul>
      <li parentName="ul">{`First item`}</li>
      <li parentName="ul">{`Second item`}</li>
      <li parentName="ul">{`Third item`}</li>
      <li parentName="ul">{`Fourth item`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-markdown"
      }}>{`- First item
- Second item
- Third item
- Fourth item
`}</code></pre>
    <h2 {...{
      "id": "with-indentation-1"
    }}>{`With indentation`}</h2>
    <ul>
      <li parentName="ul">{`First item`}</li>
      <li parentName="ul">{`Second item`}</li>
      <li parentName="ul">{`Third item`}<ul parentName="li">
          <li parentName="ul">{`Indented item`}</li>
          <li parentName="ul">{`Indented item`}</li>
        </ul></li>
      <li parentName="ul">{`Fourth item`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-markdown"
      }}>{`- First item
- Second item
- Third item
    - Indented item
    - Indented item
- Fourth item
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      